import { render } from "./Image360.vue?vue&type=template&id=2d169b12&lang=pug"
import script from "./Image360.vue?vue&type=script&lang=js"
export * from "./Image360.vue?vue&type=script&lang=js"

import "./Image360.vue?vue&type=style&index=0&id=2d169b12&lang=scss"

import exportComponent from "/schmetterlinge/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__